export default "__VITE_ASSET__3e78a79d__"